"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import { FormHelperErrorIcon, FormHelperValidIcon } from "ui"

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

type Props = {
  render: boolean
  error: boolean
  text?: string
  locale?: string
  hideIcons?: boolean
  hideSuccess?: boolean
  errorColor?: string
}

function CustomHelperText({
  render,
  error,
  text,
  hideIcons = false,
  hideSuccess = false,
  errorColor,
}: Props) {
  const t = useTranslations("ProjectsPage")
  if (!render) return null
  return (
    <StyledContainer>
      {!hideIcons && (error ? <FormHelperErrorIcon /> : <FormHelperValidIcon />)}
      <Typography
        sx={{
          margin: { xs: 0 },
          width: "100%",
          color: error ? errorColor || "#C92418" : "#008015",
          marginRight: { xs: "4px" },
          fontSize: {
            xs: "12px",
          },
          maxHeight: {
            xs: "18px",
          },
          letterSpacing: { xs: "-0.12px" },
        }}
      >
        {text || (!hideSuccess && t("completed"))}
      </Typography>
    </StyledContainer>
  )
}

export default CustomHelperText
